import './jQueryCSV'

export function tableCSV(){

    if(document.querySelector('.js-table-csv')){
        var CsvToHtmlTable = CsvToHtmlTable || {};
        CsvToHtmlTable = {
            init: function (options) {
                options = options || {};
                var csv_path = options.csv_path || "";
                var el = options.element || "table-container";
                var allow_download = options.allow_download || false;
                var csv_options = options.csv_options || {};
                var datatables_options = options.datatables_options || {};
                var custom_formatting = options.custom_formatting || [];
                var customTemplates = {};

                $.each(custom_formatting, function (i, v) {
                    var colIdx = v[0];
                    var func = v[1];
                    customTemplates[colIdx] = func;
                });
        
                var $table = $("<table class='display table table-striped table-condensed' id='" + el + "-table'></table>");
                var $containerElement = $("#" + el);
                $containerElement.empty().append($table);
        
                $.when($.get(csv_path)).then(
                    function (data) {

                        var csvData = $.csv.toArrays(data, csv_options);
                        var $tableHead = $("<thead></thead>");
                        var csvHeaderRow = csvData[0];
                        var $tableHeadRow = $("<tr></tr>");

                        // Add a default header for the first column (expand button or similar)
                        $tableHeadRow.append($("<th></th>").text(""));

                        for (var headerIdx = 0; headerIdx < csvHeaderRow.length; headerIdx++) {
                            $tableHeadRow.append($("<th></th>").text(csvHeaderRow[headerIdx]));
                        }
                        $tableHead.append($tableHeadRow);
        
                        $table.append($tableHead);
                        var $tableBody = $("<tbody></tbody>");
        
                        for (var rowIdx = 1; rowIdx < csvData.length; rowIdx++) {
                            var $tableBodyRow = $("<tr></tr>");
                            var $tableBodyRowTd = $("<td></td>");
                            $tableBodyRow.append($tableBodyRowTd);

                            for (var colIdx = 0; colIdx < csvData[rowIdx].length; colIdx++) {
                                var $tableBodyRowTd = $("<td></td>");
                                var $paragraph = $("<p></p>")
                                var cellTemplateFunc = customTemplates[colIdx];
                                if (cellTemplateFunc) {
                                    $paragraph.html(cellTemplateFunc(csvData[rowIdx][colIdx]));
                                } else {
                                    $paragraph.text(csvData[rowIdx][colIdx]);
                                }
                                $tableBodyRowTd.append($paragraph)
                                $tableBodyRow.append($tableBodyRowTd);
                                $tableBody.append($tableBodyRow);
                            }
                        }
                        $table.append($tableBody);
        
                        $table.DataTable(datatables_options);

                        if (allow_download) {
                            $containerElement.append("<a class='btn btn__primary' href='" + csv_path + "'>Download som CSV</a>");
                        }
                    });
            }
        };

        const tables = document.querySelectorAll('.js-table-csv')
        tables.forEach(table => {
            const csvPath = table.getAttribute('data-source');
            fetch(csvPath)
                .then(response => response.text())
                .then( data => {
                    // Count commas and semicolons
                    const commaCount = (data.match(/,/g) || []).length;
                    const semicolonCount = (data.match(/;/g) || []).length;

                    const separator = semicolonCount > commaCount ? ';' : ',';
                    CsvToHtmlTable.init({
                        csv_path: table.getAttribute('data-source'),
                        element: table.id,
                        allow_download: false,
                        csv_options: {
                            separator: separator,
                            delimiter: '"'
                        },
                        datatables_options: {
                            paging: table.getAttribute('data-pagination') === 'true',
                            searching: table.getAttribute('data-searching') === 'true',
                            responsive: table.getAttribute('data-responsive') === 'true' ? {
                                details: {
                                    type: 'column'
                                }
                            } : false,
                            scrollX: table.getAttribute('data-responsive') !== 'true',
                            info: table.getAttribute('data-info') === 'true',
                            lengthChange: false,
                            columnDefs: table.getAttribute('data-responsive') === 'true' ? [
                                {
                                    className: 'control',
                                    orderable: false,
                                    target: 0,
                                    visible: true
                                }
                            ] : [
                                {
                                    className: 'control',
                                    orderable: false,
                                    target: 0,
                                    visible: false
                                }
                            ],
                            order: [],
                            "language": {
                                "paginate": {
                                    "first": "",
                                    "last": "",
                                    "next": "",
                                    "previous": ""
                                },
                                "lengthMenu": "Vis _MENU_ linjer",
                                "info": "Viser _START_ til _END_ af _TOTAL_ linjer",
                                "infoFiltered": "(filtreret fra _MAX_ linjer)",
                                "search": "Søg",
                                "searchPlaceholder": "Søg",
                                "searchBuilder": {
                                    "value": "Søg",
                                },
                                "layout": {
                                    "top1": "searchBuilder"
                                } 
                            }
                        }/* ,
                        custom_formatting: [
                            [4, format_link]
                        ] */
                    });
                })


            table.querySelectorAll('table').forEach(el => {
                el.setAttribute('summary', table.getAttribute('data-summary'))
            })
        })

    }
}

export default tableCSV